import Phaser from "phaser";
import { PLAYER_NAME } from "@engine";
import { BootScene } from "./scenes/BootScene.ts";
import { VillageScene } from "./scenes/VillageScene.ts";
import { $, hide } from "./ui/dom.ts";

/** Render at the device's pixel density so the village art stays crisp. */
function pixelRatio(): number {
  return Math.min(3, Math.max(1, window.devicePixelRatio || 1));
}

function startGame(): void {
  const parent = document.getElementById("game");
  if (!parent) {
    throw new Error("#game missing");
  }
  $("hud-name").textContent = PLAYER_NAME;
  const dpr = pixelRatio();

  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    backgroundColor: "#3e8f3a",
    scale: {
      mode: Phaser.Scale.NONE,
      width: Math.round(window.innerWidth * dpr),
      height: Math.round(window.innerHeight * dpr),
      zoom: 1 / dpr,
    },
    render: {
      antialias: true,
      pixelArt: false,
    },
    input: {
      activePointers: 3,
    },
    scene: [BootScene, VillageScene],
  });
  game.registry.set("dpr", dpr);

  const resize = () => {
    const ratio = pixelRatio();
    game.registry.set("dpr", ratio);
    game.scale.resize(Math.round(window.innerWidth * ratio), Math.round(window.innerHeight * ratio));
    game.scale.setZoom(1 / ratio);
  };
  window.addEventListener("resize", resize);
}

async function gate(): Promise<void> {
  try {
    const probe = await fetch("/api/me", { credentials: "include" });
    if (probe.status === 401) {
      hide($("overlays"));
      hide($("hud"));
      $("login-wrap").classList.remove("hidden");
      $("login-form").addEventListener("submit", async (event) => {
        event.preventDefault();
        const password = ($("login-password") as HTMLInputElement).value;
        const response = await fetch("/api/login", {
          method: "POST",
          headers: { "content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ password }),
        });
        if (!response.ok) {
          $("login-error").textContent = "Wrong password.";
          $("login-error").classList.remove("hidden");
          return;
        }
        window.location.reload();
      });
      return;
    }
  } catch {
    // No Worker (local Vite or Cloudflare Pages) — play from the bundled seed.
  }
  startGame();
}

void gate();
